import React from 'react'
import { connect } from 'react-redux'

export default connect(
	(state) => ({
		description: state.signupForm.addOrEdit.values.description.value,
		descriptionTextColor:
			state.signupForm.addOrEdit.values.descriptionTextColor.value,
	}),
	null,
)(({ description, descriptionTextColor }) => (
	<p
		style={{
			color: descriptionTextColor,
			fontSize: '16px',
			display: 'block',
			marginBlockStart: '1em',
			marginBlockEnd: '1em',
			marginInlineStart: '0px',
			marginInlineEnd: '0px',
		}}
	>
		{description}
	</p>
))
